import {defineStore} from "pinia";
import {reactive} from "vue";

export const useSnackbarStore = defineStore('snackbar', () => {
    const snackbar = reactive({
        show: false, message: null, color: 'success', timeout: 3000
    });

    const showSnackbar = (message, color = 'success', timeout = 3000) => {
        snackbar.show = true;
        snackbar.message = message;
        snackbar.color = color;
        snackbar.timeout = timeout;
    }

    const hideSnackbar = () => {
        snackbar.value.show = false;
    }

    const setSnackbarShow = (value) => {
        snackbar.value.show = value;
    }

    return {
        snackbar, showSnackbar, hideSnackbar, setSnackbarShow
    }
})
